import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { getOrder } from '../../store/actions/orders_action';
import Spinner from '../../components/layout/Spinner';
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/orders_enum';
import SingleView from '../../components/common/SingleView';
const ViewOrder = ({ getOrder, match, order: { loading, order } }) => {
  useEffect(() => {
    getOrder(match.params.id);
  }, [match]);
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='View'
        />
        {!loading ? (
          order && (
            <SingleView
              data={order}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={order.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ order: state.order });

const mapDispatchToProps = { getOrder };

export default connect(mapStateToProps, mapDispatchToProps)(ViewOrder);
